import type { StoredConsent } from "@/types/consent";

export const COOKIE_CONSENT_EVENT_NAME = "vts-cookie-consent-change";
export const COOKIE_CONSENT_STORAGE_KEY = "vts-cookie-consent";
export const COOKIE_CONSENT_DAYS = 180;
export const COOKIE_CONSENT_TTL_MS = COOKIE_CONSENT_DAYS * 24 * 60 * 60 * 1000;

function isBrowser(): boolean {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function hasCookieConsent(): boolean {
  if (!isBrowser()) return false;

  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return false;

    const stored = JSON.parse(raw) as Partial<StoredConsent>;
    if (stored.version !== 1 || !stored.expiresAt || stored.expiresAt <= Date.now()) {
      window.localStorage.removeItem(COOKIE_CONSENT_STORAGE_KEY);
      return false;
    }

    return true;
  } catch {
    return false;
  }
}

export function setCookieConsentAccepted(days = COOKIE_CONSENT_DAYS): void {
  if (!isBrowser()) return;

  const now = new Date();
  const stored: StoredConsent = {
    version: 1,
    acceptedAt: now.toISOString(),
    expiresAt: now.getTime() + days * 24 * 60 * 60 * 1000
  };

  window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(stored));
  window.dispatchEvent(new Event(COOKIE_CONSENT_EVENT_NAME));
}
